// React
import React from 'react';
import { Col, Row } from 'reactstrap';

// Containers Injections
import {
  CardAccount,
  FloatButton,
  PageWrapper,
} from '../../containers/componentsInjection';

export const AccountListPage = ({
  accounts,
  handleButton,
  handleEditAccount,
  handleDeleteAccount,
}) => {
  return (
    <PageWrapper title="Contas">
      <Row>
        <Col xs={12}>
          {(accounts || []).map((itemAccount) => (
            <CardAccount
              key={itemAccount.id}
              item={itemAccount}
              handleDelete={handleDeleteAccount}
              handleEdit={handleEditAccount}
            />
          ))}
        </Col>
      </Row>

      <FloatButton
        handleButton={() => handleButton('/financeiro/contas/novo')}
      />
    </PageWrapper>
  );
};
